module.exports = __webpack_public_path__ + "img/product-1.ffc2dfb7.jpeg";